import { createContext } from "react";

import { useRequiredContext } from "~/tools/use-required-context";

import type { TimestampCursorState } from "./TimestampCursorState";

const TimestampCursorContext = createContext<null | TimestampCursorState>(null);

export const TimestampCursorContextProvider = TimestampCursorContext.Provider;

export const useTimestampCursorState = (): TimestampCursorState =>
	useRequiredContext(TimestampCursorContext, {
		providerName: "TimestampCursorProvider",
	});
